import { Call, Link, Mail } from "@mui/icons-material";
import SvgIcon from '@mui/material/SvgIcon';
import React from "react";
import { ColumnData } from "../data/DataTable";
import Logo from "../../icons/Logo";
import { Person } from "../../models/Types";

type SvgIconComponent = typeof SvgIcon;
const buildContacts = (client: PersonListDto, field: keyof PersonListDto, icon: SvgIconComponent, type: string) => {
    const contacts = client[field] as string[];
    return contacts
        .map((x, i) => <a key={field + i} className="contact-info-link" href={type + ':' + x}>{React.createElement(icon, { color: 'error' })}{x}</a>);
}

export class PersonListDto extends Person {
    static parse(d: any) {
        const dto = new PersonListDto();
        Object.assign(dto, d);
        d.createDate && (dto.CreateDate = new Date(d.createDate));
        return dto;
    }

    get contacts() {
        var result = [];
        if (this.Phones?.length) {
            result.push(buildContacts(this, 'Phones', Call, 'tel'));
        }

        if (this.Emails?.length) {
            result.push(buildContacts(this, 'Emails', Mail, 'mailto'));
        }

        if (this.Links?.length) {
            result.push(this.Links.map((x, i) => <div key={'link' + i} className="contact-info-link"><Link color='error' />{x}</div>));
        }

        return result;
    }
}

export const personListColumns: ColumnData<PersonListDto>[] = [
    {
        label: 'Имя',
        name: 'fio',
        filter: true,
        routerLink: true
    },
    {
        width: 185,
        label: 'Контакты',
        name: 'contacts',
        sx: () => {
            return { fontSize: undefined }
        },
        filterFn: (filterValue, e) => {
            const fv = (filterValue as string).toLowerCase();
            return !!e.Emails.find(x => x.toLowerCase().indexOf(fv) >= 0)
                || !!e.Phones.find(x => x.toLowerCase().indexOf(fv) >= 0)
                || !!e.Links.find(x => x.toLowerCase().indexOf(fv) >= 0)
                || !!e.EmailNames.find(x => x.toLowerCase().indexOf(fv) >= 0)
                || !!e.PhoneNames.find(x => x.toLowerCase().indexOf(fv) >= 0)
                || !!e.LinkNames.find(x => x.toLowerCase().indexOf(fv) >= 0);
        },
        filter: true
    },
    {
        width: 205,
        label: 'Дата регистрации',
        name: 'CreateDate',
        type: 'date',
        filter: 'date'
    },
    {
        width: 75,
        label: 'Пользователь',
        name: 'UserId',
        filter: 'boolean',
        filterFn: (filterValue, entity) => !!entity.UserId == filterValue,
        renderer: (val) => val ? <div style={styles.cellIcon}><Logo style={{ height: '100%' }} /></div> : null
    },
];

const styles = {
    cellIcon: {
        height: '2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
    }
}